import React from 'react';
import {
    Route
} from 'react-router-dom';
import { Redirect } from 'react-router';

import { useSelector } from 'react-redux';

function ActivationProtectedRoute ({ children, ...otherProps }) {
    const lastActivation = useSelector(state => state.user.lastActivation);
    const isActive = lastActivation && lastActivation.isActive;
   
    return (
        <Route {...otherProps}>
            { 
                isActive ?
                    children :
                    <Redirect to="/inactive" /> 
            }
        </Route>
    );
}

export default ActivationProtectedRoute;